
import {cloneDeep} from 'lodash'
import {
    extFromMineType,
    formatSize, isAudioAnnoElement,
    isAudioFileElement, isCardAnnoElement,
    isFileElement,
    isFileVideoElement,
    isNoteElement, isObject, isPdfAnnoElement,
    isPdfFileElement, isShape, isString,
    isStringNullOrEmpty, isVideoAnnoElement, recursionMindmapData,
    removeHtmlTags
} from "@/utils";
import {postMessage, triggerEvent} from "@/common/event";
import {
    EVENT_NOTE_CHANGED,
    EVENT_NOTE_DELETE,
    EVENT_NOTE_DELETE_FOREVER, EVENT_REFRESH_RECENTS,
    INIT_ID_GETTING_START_0, KEY_DEFAULT_PROJECT_ID,
    KEY_FILE_DIR, PAGE_SIZE, SYS_CONFIG_KEY_ORDER_BY, SYS_CONFIG_KEY_SORT_TYPE
} from "@/Const";
import {TNote} from "@/index";
import {deleteCard, getCardByIds, getCardDoc, getDeletedCardList, updateCard} from "@model/card";
import {apiProjectById, apiProjectList, apiUpdateProject} from "@/api/AppApi";
import {isWebApp} from "@/electron_interactive";
import {updateProjectHistory} from "@model/projectHistory";
import {ipcInvoke} from "@/common/ipc";
import {getSysConfig} from "@model/sysconfig";
import {findNodeWithParents, loopAllNode, loopAllNodeAsync} from "@/TreeUtils";
import global from "@/global";
import {getBoardById} from "@model/board";
import {imgServer} from "@/components/EditorV2/imgServer";
import {getPublishNoteById, getPublishNoteListInPublish} from "@model/publishNote";


let note:any;
let noteDoc:any;
let mDb;
let mIsHooking = false;

export function initNote(db){
    mDb = db;
    note = db.table('note');
    noteDoc = db.table('doc');
}

export function updateDeleteOrFavor(){
    // note.toArray().then(res=>{
    //     for (let i=0;i<res.length;i++){
    //         res[i].isDeleted = 0;
    //     }
    //     note.bulkPut(res);
    // })
}

function hookFunc(obj:TNote){
    if (mIsHooking){
        obj.doc = '';
    }
    return obj;
}

function hookListReading(){
    // mIsHooking = true;
    // mDb.note.hook('reading',hookFunc)
}

function unHookListReading(){
    // mIsHooking = false;
    // mDb.note.hook('reading').unsubscribe(hookFunc);
}

/** 新增 */
export function addNote(data){
    data= cloneDeep(data)
    delete data.img
    delete data.doc
    data.showName = removeHtmlTags(data.name);
    note.add(data)
}

export async function getProjectByIds(arrayIds:any){
    return note.bulkGet(arrayIds);
}

/** 修改 */
export function editNote(data){
    data= cloneDeep(data)
    data.updateTime = new Date().getTime();
    data.showName = removeHtmlTags(data.name);
    delete data.img
    delete data.doc
    note.put(data)
}

/** 删除 */
export async function delNote(data){
    //补充下doc
    // if (isStringNullOrEmpty(data.doc)){
    //     const dbNoteData = await getNoteById(data.id);
    //     if (dbNoteData != undefined){
    //         data.doc = dbNoteData.doc;
    //     }
    // }
    data.folderId = 0;//删除后文件夹不归属。针对查询的优化......
    data.isDeleted = 1;
    data.updateTime = Date.now();
    data.deleteTime = new Date().getTime();
    if (isWebApp()){
        apiUpdateProject(data).then(res=>{
            if (res.code == 0){
                postMessage(EVENT_NOTE_CHANGED)
                postMessage(EVENT_NOTE_DELETE);
                postMessage(EVENT_REFRESH_RECENTS);
            }
        })
    }else{
        note.put(data).then(res=>{
            postMessage(EVENT_NOTE_CHANGED)
            postMessage(EVENT_NOTE_DELETE);
            postMessage(EVENT_REFRESH_RECENTS);
        })
    }
}

export function delNoteForever(id){
    // note.delete(id).then(async (res)=>{
    //     //处理图片元素，如果不在库里就把图片删了...
    //     const doc = await getNoteJsonDoc(id);
    //     loopAllNode(doc.canvas,(canvas)=>{
    //         if (canvas.drawJson?.elements){
    //             const arrayImgs = canvas.drawJson.elements.filter(p=>p.type == 'image');
    //             for (let j=0;j<arrayImgs.length;j++){
    //                 const element = arrayImgs[j];
    //                 if (element.customData?.generationData?.id){
    //
    //                 }else{
    //                     const file = canvas.drawJson.files[element.fileId];
    //                     if (file && !file.fullPath){//非绝对路径...
    //                         ipcInvoke('delete-files-file',{fileName:file.id+"."+extFromMineType(file.mimeType)})
    //                     }
    //                 }
    //             }
    //         }
    //     })
    //
    //     noteDoc.delete(id);
    //     postMessage(EVENT_NOTE_DELETE_FOREVER)
    // })
    delNoteSync(id).then(res=>{
        // postMessage(EVENT_NOTE_DELETE_FOREVER);
        if (window.refreshTrash){
            window.refreshTrash();
        }
    });
}

/**
 * 判断这个fileId是否在别的项目中还有...
 * @param fileId
 */
export async function hasInOtherProject(arrayDocs,selfProjectId,fileId:any){
    let bExist = false;
    const arrayProjectLists = await getNoteListAll(0);
    for (let i=0;i<arrayProjectLists.length;i++){
        if (arrayProjectLists[i].id == selfProjectId)continue;
        const doc = await getNoteJsonDoc(arrayProjectLists[i].id);
        if (doc && isObject(doc.canvas) && doc.canvas){
            loopAllNode(doc.canvas,(canvas)=>{
                if (!bExist && canvas.drawJson?.files){
                    if (canvas.drawJson.files[fileId]){
                        bExist = true;
                    }
                }
            })
        }
    }
    return bExist;
}


async function delNoteSync(id){
    return new Promise((resolve, reject) => {
        note.delete(id).then(async (res)=>{
            const doc = await getNoteJsonDoc(id);
            const arrayDocs:any = [];//await getNoteDocList();--不能这种取，大数据没办法处理...会内存溢出。。。需要找里面的元素，没好的方式处理忽略这个判断....

            await loopAllNodeAsync(doc.canvas,async (canvas)=>{
                if (canvas.drawJson?.elements){
                    const arrayImgs = canvas.drawJson.elements.filter(p=>p.type == 'image');
                    for (let j=0;j<arrayImgs.length;j++){
                        const element = arrayImgs[j];
                        const hasInOther = await hasInOtherProject(arrayDocs,id,element.fileId);
                        if (element.customData?.generationData?.id || hasInOther){
                            //库里面有的，直接忽略....
                        }else{
                            const file = canvas.drawJson.files[element.fileId];
                            if (file){
                                const szFileName = file.id + '.' + extFromMineType(file.mimeType);
                                const szFileName1 = element.customData?.generationData?.originName + '.jpg';
                                let szFullPath = file.fullPath;

                                //全部删...
                                if (file && !file.fullPath){//非绝对路径...
                                    ipcInvoke('delete-files-file',{fileName:szFileName})
                                }
                                ipcInvoke('delete-files-file',{fileName:szFileName1});
                                if (szFullPath && szFullPath.startsWith(localStorage.getItem(KEY_FILE_DIR))){
                                    ipcInvoke('delete-files-file',{fileName:szFullPath,isAbsolutePath:true});
                                }
                            }
                        }
                    }

                    for (let i=0;i<canvas.drawJson.elements.length;i++){
                        const element = canvas.drawJson.elements[i];
                        if (element.type == 'text' || (element.type == 'stickyNotes')){
                            const arrayImgs = imgServer.getImageListFromHtml(element.value);
                            //全部删除了。
                            for (let kk = 0;kk<arrayImgs.length;kk++){
                                const szFileName = arrayImgs[kk].fileName
                                ipcInvoke('delete-files-file',{fileName:szFileName})
                            }
                        }
                    }
                }
            })

            //delete doc
            noteDoc.delete(id);
            resolve('ok');
        });
    })
}

/**
 * 清空回收站
 */
export async function clearTrashNote(){
    let arrayNotes = await note.toArray();
    arrayNotes = arrayNotes.filter(p=>p.isDeleted === 1);
    for (var i = 0; i < arrayNotes.length; i++) {
        await delNoteSync(arrayNotes[i].id);
    }

    //删除card...
    const arrayCards = await getDeletedCardList();
    for (let i=0;i<arrayCards.length;i++){
        deleteCard(arrayCards[i].id);
    }
    // postMessage(EVENT_NOTE_DELETE_FOREVER)
}

/**
 * 从card关联的项目中删除所有
 */
export async function deleteAllCardFromRefProject(card:any){
    return new Promise(async (resolve, reject) => {
        getNoteList().then(async (res:any)=>{
            for (let i=0;i<res.length;i++){
                const jsonObj = await getNoteDoc(res[i].id);
                const jsonDoc = JSON.parse(jsonObj.doc);
                let isUpdate = false;
                if (card.type == 'card'){
                    for (let j=jsonDoc.notes?.length-1;j>=0;j--){
                        if (jsonDoc.notes[j].key == card.id){
                            jsonDoc.notes.splice(j,1);
                            isUpdate = true;
                        }
                    }
                }

                for (let k=0;k<jsonDoc?.canvas?.length;k++) {
                    const canvas = jsonDoc.canvas[k];
                    for (let j = canvas.drawJson?.elements?.length-1; j >=0 ; j--) {
                        const element = canvas.drawJson.elements[j];
                        if (isFileElement(element) || isNoteElement(element)){
                            if (element.customData?.generationData?.id == card.id){
                                canvas.drawJson.elements.splice(j,1);
                                isUpdate = true;
                            }
                        }
                    }
                }

                if (isUpdate){
                    jsonObj.doc = JSON.stringify(jsonDoc);
                    updateNoteDoc(jsonObj);
                }
            }
            resolve('ok');
        })
    })
}

export function getNoteListAll(isDeleted:any){
    return note.where('isDeleted').equals(isDeleted).toArray()
}

/**
 * 查询列表
 * @param isDeleted
 * @param folderId
 */
export async function getNoteList(isDeleted= 0,folderId='-2',nPageNum = -1,isFavirated = false){

    let szSortType:any = localStorage.getItem(SYS_CONFIG_KEY_SORT_TYPE)// || await getSysConfig(SYS_CONFIG_KEY_SORT_TYPE);//"sort by updateDate";//
    let szOrderBy:any = localStorage.getItem(SYS_CONFIG_KEY_ORDER_BY)// || "date desc"; //await getSysConfig(SYS_CONFIG_KEY_ORDER_BY);
    if (!szSortType){
        const dbConfig = await getSysConfig(SYS_CONFIG_KEY_SORT_TYPE);
        if (dbConfig && dbConfig.value){
            szSortType = dbConfig.value;
        }else{
            szSortType = 'sort by updateDate';
        }
        localStorage.setItem(SYS_CONFIG_KEY_SORT_TYPE,szSortType)
    }
    if (!szOrderBy){
        const dbConfig = await getSysConfig(SYS_CONFIG_KEY_ORDER_BY);
        if (dbConfig && dbConfig.value){
            szOrderBy = dbConfig.value;
        }else{
            szOrderBy = 'date desc';
        }
        localStorage.setItem(SYS_CONFIG_KEY_ORDER_BY,szOrderBy)
    }


    if (isWebApp()){
        return new Promise((resolve, reject) => {
            apiProjectList(isDeleted).then(res=>{
                if (res.code == 0){
                    resolve(res.data);
                }
                resolve([]);
            })
        })
    }else{
        // hookListReading();
        if (!isStringNullOrEmpty(folderId) && folderId != '-2'){
            //带文件夹的
            return new Promise((resolve, reject) => {
                note.where({'folderId':folderId})
                    .toArray().then(res=>{
                    // unHookListReading();
                    resolve(res);
                });
            })
        }else{

            return new Promise((resolve, reject) => {
                // note.toCollection().modify(p=>{
                //     delete p.doc;
                // }).then(res=>{
                //     resolve(res);
                // });
                let dbNotes = null;//note.where('isDeleted').equals(isDeleted);
                if("sort by name" === szSortType){
                    if("a-z" === szOrderBy){
                        dbNotes = note.orderBy('name');
                    }else if("z-a" == szOrderBy){
                        dbNotes = note.orderBy('name').reverse();
                    }
                }else if("sort by createDate" == szSortType){
                    if("date asc" == szOrderBy){
                        dbNotes = note.orderBy('createTime');
                    }else if("date desc" == szOrderBy){
                        dbNotes = note.orderBy('createTime').reverse();
                    }
                } else if("sort by updateDate" == szSortType){
                    if("date asc" == szOrderBy){
                        dbNotes = note.orderBy('updateTime');
                    }else if("date desc" == szOrderBy){
                        dbNotes = note.orderBy('updateTime').reverse();
                    }
                }
                if (isFavirated){
                    dbNotes = dbNotes.filter(p=>p.isDeleted == isDeleted && p.isFavirated == 1);
                }else{
                    dbNotes = dbNotes.filter(p=>p.isDeleted == isDeleted);
                }

                if (nPageNum != -1){
                    dbNotes = dbNotes.offset(nPageNum*PAGE_SIZE).limit(PAGE_SIZE)
                }
                dbNotes.toArray().then(res=>{
                    // unHookListReading();
                    resolve(res);
                });
            })
        }
    }
}

/**
 * 查询发布的
 */
export function getPublishProjectList(szType:any){
    return new Promise((resolve) => {
        getPublishNoteListInPublish().then(async (res)=>{
            const arrayProjectIds:any = [];
            for (let i=0;i<res.length;i++){
                arrayProjectIds.push(res[i].id);
            }
            if (szType == 'project'){
                let arrayProjects = await note.bulkGet(arrayProjectIds);
                arrayProjects = arrayProjects.filter(p=>p && p?.isDeleted == 0);
                resolve(arrayProjects);
            }else if (szType == 'card'){
                let arrayLibrarys = await getCardByIds(arrayProjectIds);
                arrayLibrarys = arrayLibrarys.filter(p=>p && p?.isDeleted == 0);
                resolve(arrayLibrarys);
            }
            resolve([]);
        })
    })
}


/**
 * 获取所有，包括删除的
 */
export function getAllNoteList(){
    return note.toArray();
}

export async function removeAllProjectTags(szTagName:any){
    if (!szTagName)return;

    const arrayProjects = await note.toArray();
    for (let i=0;i<arrayProjects.length;i++){
        const project = arrayProjects[i];
        if (project.tags?.includes(szTagName)){
            const nIndex = project.tags.indexOf(szTagName);
            project.tags.splice(nIndex,1);
            //更新project 的  tag
            note.put(project);
        }
    }
}

/**
 * 取列表数据，不包括删除的
 */
export function getNoteListCount(){
    return new Promise((resolve, reject) => {
        note.where('isDeleted').equals(0).toArray().then(res=>{
            const len = res.filter(p=>p.id != INIT_ID_GETTING_START_0).length;
            resolve(len);
            resolve(res.length);
        });
    })
}

/**
 * 取列表数据，不包括删除的-也不包括home
 */
export function getNoteListExcludeHomeCount(){
    return new Promise((resolve, reject) => {
        note.where('isDeleted').equals(0).toArray().then(res=>{
            const len = res.filter(p=>(p.id != INIT_ID_GETTING_START_0 /*&& p.id != KEY_DEFAULT_PROJECT_ID*/)).length;
            resolve(len);
            resolve(res.length);
        });
    })
}

//统计文件夹下的笔记数量
export async function staticFolderNoteCount(folderId){
    return note.where({'folderId':folderId}).count();
}

/**
 * 查询收藏列表
 */
export function getFavorList(){
    hookListReading();
    return new Promise((resolve, reject) => {
        if (isWebApp()){
            apiProjectList(0,1).then(res=>{
                if (res.code == 0){
                    resolve(res.data);
                }else{
                    reject(res.message);
                }
            })
        }else{
            note.where('isFavirated').equals(1).toArray().then(res=>{
                // unHookListReading();
                resolve(res);
            })
        }
    })
}

/**
 * 查询最近--按updateTime取前6条.
 */
export function getProjectRecentsList(){
    return note.orderBy('updateTime').desc().filter(p=>p.isDeleted == 0 && !p.isDefaultProject).offset(0).limit(20).toArray();
}

//搜索......
export function getSearchNoteList(szKey,isIncludeChildBoard = false,isFavor = false,isPublished = false){
    return new Promise( (resolve, reject) => {
        hookListReading();
        szKey = szKey.toLowerCase();
        note.filter(p=>p.isDeleted===0 /*&& (p.name.toLowerCase().indexOf(szKey)>=0)*/).toArray().then(async res => {
            var arraySearchs:any = [];

            for (let j=0;j<res.length;j++) {
                const p = res[j];
                if (isFavor){
                    if (p.isFavirated != 1)continue;
                }
                if (isPublished){
                    const projectPublished = await getPublishNoteById(p.id);
                    if (!projectPublished)continue;
                }

                if (!p.isDeleted) {
                    var bFind = false;
                    if (p.name?.toLowerCase().indexOf(szKey) != -1) {
                        arraySearchs.push(p);
                    } else {
                        try{
                            let noteDDDDDOOOOCCCC = await getNoteJsonDoc(p.id);
                            if (noteDDDDDOOOOCCCC) {
                                var jsonDoc = noteDDDDDOOOOCCCC;
                                var jsonPages = jsonDoc.canvas;
                                await loopAllNodeAsync(jsonPages,async (page)=>{
                                    if (/*!bFind &&*/ page.drawJson?.elements){
                                        let newP = {...p};
                                        newP.type = 'project';
                                        if (isIncludeChildBoard){
                                            newP.pageId = page.key;
                                            newP.parentBoards = [{key:newP.id,title:newP.name}];
                                            //使用子画板的缩略图.
                                            const board = await getBoardById(page.key);
                                            if (board){
                                                newP.thumbUrl = board.thumbUrl;
                                            }
                                            const parents = findNodeWithParents(jsonPages,page.key);
                                            if (parents.parents){
                                                newP.parentBoards.push(...parents.parents);
                                            }
                                            if (jsonPages.length == 1){
                                                newP.boardName = p.name ;
                                            }else{
                                                newP.boardName = p.name + '/' + page.title;
                                            }
                                        }

                                        if (page.title.toLowerCase().includes(szKey)){
                                            bFind = true;
                                            arraySearchs.push(newP);
                                        }else{
                                            //region 搜索元素
                                            var arrayEles = page.drawJson.elements;
                                            for (var i = 0; i < arrayEles.length; i++) {
                                                var ele = arrayEles[i];
                                                if (ele?.customData?.generationData?.infoNotes?.toLowerCase()?.includes(szKey)){
                                                    bFind = true;
                                                    arraySearchs.push(newP);
                                                    break;
                                                }
                                                if (ele.name && ele.name.toLowerCase().includes(szKey)){
                                                    bFind = true;
                                                    arraySearchs.push(newP);
                                                    break;
                                                }
                                                if (ele.type === 'text') {
                                                    let szTxt = ele.text || '';
                                                    if (szTxt.toLowerCase().indexOf(szKey) != -1 || removeHtmlTags(ele.value).toLowerCase().indexOf(szKey) != -1) {
                                                        bFind = true;
                                                        arraySearchs.push(newP);
                                                        break;
                                                    }
                                                }else if (ele.type == 'stickyNotes'){
                                                    if (removeHtmlTags(ele.value)?.toLowerCase().indexOf(szKey) != -1) {
                                                        bFind = true;
                                                        arraySearchs.push(newP);
                                                        break;
                                                    }
                                                } else if (ele.type == 'iframe') {
                                                    var szHtml = ele.customData?.generationData?.html;
                                                    if (ele.customData?.generationData?.name && ele.customData?.generationData?.name?.toLowerCase()?.indexOf(szKey) != -1) {
                                                        bFind = true;
                                                        arraySearchs.push(newP);
                                                        break;
                                                    }
                                                    else {
                                                        if (isPdfAnnoElement(ele) || isCardAnnoElement(ele)){
                                                            //pdf注记
                                                            const pdfData = ele.customData.generationData.pdfData;
                                                            if (pdfData?.name?.toLowerCase()?.includes(szKey) || pdfData?.text?.toLowerCase()?.includes(szKey) || pdfData?.comment?.toLowerCase()?.includes(szKey)){
                                                                bFind = true;
                                                                arraySearchs.push(newP);
                                                                break;
                                                            }
                                                        }else if (isVideoAnnoElement(ele) || isAudioAnnoElement(ele)){
                                                            const videoData = ele.customData.generationData.videoData;
                                                            if (videoData?.title?.toLowerCase()?.includes(szKey) || videoData?.content?.toLowerCase()?.includes(szKey) || videoData?.comment?.toLowerCase()?.includes(szKey)){
                                                                bFind = true;
                                                                arraySearchs.push(newP);
                                                                break;
                                                            }
                                                        }
                                                        else if(!isStringNullOrEmpty(szHtml)) {
                                                            var szTxt = removeHtmlTags(szHtml);
                                                            if (szTxt.toLowerCase().indexOf(szKey) != -1) {
                                                                bFind = true;
                                                                arraySearchs.push(newP);
                                                                break;
                                                            }
                                                        }
                                                    }
                                                }else if (ele.type == 'mindmap'){
                                                    const mindmapData = ele.data;
                                                    await recursionMindmapData(mindmapData,(mindmapData:any)=>{
                                                        const szTxt = removeHtmlTags(mindmapData.text);
                                                        if (szTxt.toLowerCase().includes(szKey)){
                                                            bFind = true;
                                                            if (!arraySearchs.includes(newP)){
                                                                arraySearchs.push(newP);
                                                            }
                                                        }
                                                    })
                                                    if (bFind)break;
                                                }else if (ele.type == 'stickyNotes'){
                                                    if (ele.value && ele.value.toLowerCase().includes(szKey)){
                                                        bFind = true;
                                                        arraySearchs.push(newP);
                                                        break;
                                                    }
                                                }
                                            }
                                            //endregion
                                        }
                                    }
                                })
                                // for (var nPages = 0; nPages < jsonPages.length; nPages++) {
                                //     var page = jsonPages[nPages];
                                //     if (page.drawJson != undefined && page.drawJson.elements != undefined) {
                                //
                                //     }
                                //     if (bFind) break;
                                // }

                                //未找到--找card.....
                                if (!bFind) {
                                    var jsonNote = jsonDoc.notes;
                                    for (var i = 0; i < jsonNote.length; i++) {
                                        var item = jsonNote[i];
                                        if (item.title?.toLowerCase().includes(szKey)){
                                            arraySearchs.push(p);
                                            break;
                                        }
                                        var szText = removeHtmlTags(item.noteDataDoc).toLowerCase();
                                        if (szText.includes(szKey)) {
                                            arraySearchs.push(p);
                                            break;
                                        }
                                    }
                                }
                            }
                        }catch (e) {

                        }
                    }
                }
            }

            //提取带标题的在前面.
            const arrayIncludeTitles:any = [];
            for (let i=0;i<arraySearchs.length;i++){
                const proj = arraySearchs[i];
                if (proj.name?.toLowerCase()?.includes(szKey)){
                    arrayIncludeTitles.push(proj);
                }
            }
            arrayIncludeTitles.sort((a,b)=>{
                return a.name.localeCompare(b.name);
            })
            let arrayNewSearchs:any = [...arrayIncludeTitles];
            for (let i=0;i<arraySearchs.length;i++){
                const proj = arraySearchs[i];
                if (!arrayNewSearchs.some(p=>p.id == proj.id)){
                    arrayNewSearchs.push(proj);
                }
            }

            resolve(arrayNewSearchs);
        })
    })
}

export const getNoteDoc = async (szNoteId:string)=>{
    var doc = await noteDoc.get(szNoteId);
    if (doc && !isString(doc?.doc)){
        doc.doc = JSON.stringify(doc.doc);
    }
    return doc;
}

/**
 * 只获取json格式的数据
 * @param szId
 */
export const getNoteJsonDoc = async (szId:string)=>{
    const projectData = await noteDoc.get(szId);
    if (isString(projectData?.doc)){
        return JSON.parse(projectData.doc);
    }
    return projectData?.doc;
}

/**
 * notedoc列表
 */
export const getNoteDocList = ()=>{
    return noteDoc.toArray();
}

/**
 * 总board数量
 */
export const getBoardCount = (szExcludeId:any)=>{
    return new Promise(resolve => {
        getNoteList().then(async (res:any)=>{
            let nCount = 0;
            if (res){
                for (let i=0;i<res.length;i++){
                    if (res[i].id == szExcludeId)continue;

                    const doc = await getNoteJsonDoc(res[i].id);
                    loopAllNode(doc.canvas,(node)=>{
                        if (node.drawJson?.elements){
                            nCount += 1;
                        }
                    })
                    // nCount += doc.canvas.length;
                }
            }
            resolve(nCount);
        })
    })
}

/**
 * 总文本内容的数量--这里只统计  便利贴，文本元素，形状
 */
export const getTextElementCount = (szExcludeId:any)=>{
    return new Promise(resolve => {
        getNoteList().then(async (res:any)=>{
            let nCount = 0;
            if (res){
                for (let i=0;i<res.length;i++){
                    if (res[i].id == szExcludeId)continue;

                    const doc = await getNoteJsonDoc(res[i].id);
                    loopAllNode(doc.canvas,(node)=>{
                        if (node.drawJson?.elements){
                            nCount += node.drawJson.elements.filter(element=>element.type == 'stickyNotes' || element.type == 'text' || isShape(element.type)).length;
                        }
                    })
                }
            }
            resolve(nCount);
        })
    })
}


/**
 * 更新note的doc部分
 * @param doc
 */
export const updateNoteDoc = (doc:any)=>{
    let newDoc = {...doc};
    if (isString(newDoc.doc)){
        newDoc.doc = JSON.parse(newDoc.doc);
    }
    return noteDoc.put(newDoc);
}

/**
 * 直接读取json格式的
 * @param szNoteId
 */
export function getJsonNoteById(szNoteId:any){
    return new Promise((resolve, reject) => {
        if (!szNoteId)resolve(null);
        note.get(szNoteId).then(async (r:any)=>{
            if (!r){
                resolve(null);
                return;
            }
            if(isStringNullOrEmpty(r.doc)){
                const doc = await getNoteJsonDoc(szNoteId);
                r.doc = doc;
                resolve(r);
            }else{
                resolve(r);
            }
        })
    })
}

export function getProjectById(szNoteId:string,isRequireDoc:boolean=true){
    return getNoteById(szNoteId,isRequireDoc);
}

export function getNoteById(szNoteId:string,isRequireDoc:boolean=true,isJsonDoc:boolean = false){
    // unHookListReading();
    return new Promise((resolve, reject) => {
        if (!szNoteId)resolve(null);
        if (isWebApp()){
            apiProjectById(szNoteId).then(res=>{
                if (res.code == 0){
                    resolve(res.data);
                }else{
                    reject(res.message);
                }
            })
        }else{
            note.get(szNoteId).then(async (r:any)=>{
                if (!r){
                    resolve(null);
                    return;
                }
                r.type = 'project';

                if(isRequireDoc && isStringNullOrEmpty(r.doc)){
                    // console.log('r doc is null.......');
                    if (isJsonDoc){
                        const doc = await getNoteJsonDoc(szNoteId);
                        r.doc = doc;
                    }else{
                        const doc = await getNoteDoc(szNoteId);
                        r.doc = doc?.doc;
                    }
                    resolve(r);
                }else{
                    // console.log('r doc is ok.......');
                    // console.log(JSON.stringify(r))
                    resolve(r);
                }
            })
        }
    })
}

export function statusProjectTagCountByTagName(szTagName){
    return note.where('tags').equals(szTagName).filter(p=>p.isDeleted == 0).count();
}

export function getNoteJsonById(szId,isRequireDoc=true){
    return new Promise((resolve, reject) => {
        if (!szId)resolve(null);
        if (isWebApp()){
            apiProjectById(szId).then(res=>{
                if (res.code == 0){
                    resolve(res.data);
                }else{
                    reject(res.message);
                }
            })
        }else{
            note.get(szId).then(async (r:any)=>{
                if (!r){
                    resolve(null);
                    return;
                }
                if(isRequireDoc && isStringNullOrEmpty(r.doc)){
                    // console.log('r doc is null.......');
                    const doc = await getNoteJsonDoc(szId);
                    r.doc = doc;
                    resolve(r);
                }else{
                    resolve(r);
                }
            })
        }
    })
}

/**
 * 更新项目的查看时间
 * @param szId
 */
export function updateProjectViewTime(szId:any){
    return new Promise(async (resolve) => {
        const project = await note.get(szId);
        if (project){
            project.viewTime = Date.now();
            await note.put(project);
            resolve('ok');
        }
    })
}

/**
 * 根据ID获取 一个.
 * @param szNoteId
 */
export function getNoteByIdNoDoc(szNoteId:string){
    return note.get(szNoteId);
}


export function isNoteIdExist(szNoteId:string){
    return new Promise((resolve, reject) => {
        note.get(szNoteId).then(res=>{
            resolve(res != null);
        })
    })
}


export async function resetNoteFolderIdEmpty(szFolderId:string){
    return new Promise((resolve, reject) => {
        note.toArray().then(async res => {
            var arrayTmp = res.filter(p => p.folderId === szFolderId);
            for (var i = 0; i < arrayTmp.length; i++) {
                var item = arrayTmp[i];
                item.folderId = '';
                await note.put(item);//更新........
            }
            resolve();
        })
    })
}

/**
 * 更新笔记数据
 * @param noteData
 */
export async function updateNote(noteData:any,szOriId='',isSaveForServer:boolean=true){
    //补充下doc
    let noteDataDoc = noteData.doc;
    if (isStringNullOrEmpty(noteData.doc)){
        const dbNoteData = await getNoteById(isStringNullOrEmpty(szOriId)?noteData.id:szOriId);
        if (dbNoteData != undefined){
            noteDataDoc = dbNoteData.doc;
        }
    }

    //将doc置空，只保存基本信息...
    noteData.doc = '';
    delete noteData.isHover;
    delete noteData.isSelected;
    delete noteData.isOpen;
    delete noteData.isChecked;

    await note.put(noteData);
    if (isString(noteDataDoc)){
        noteDataDoc = JSON.parse(noteDataDoc);//转成json存储....
    }
    let docData = {
        id:noteData.id,
        doc:noteDataDoc
    }
    await noteDoc.put(docData)
    // return new Promise((resolve, reject) => {
    //     note.put(noteData).then(res=>{
    //         resolve();
    //     });
    // })

    //更新历史记录
    updateProjectHistory({...noteData,doc:noteDataDoc},)

    if (isSaveForServer && isWebApp()){
        return new Promise((resolve, reject) => {
            apiUpdateProject(noteData).then(res=>{
                if (res.code == 0){
                    resolve('ok');
                }else{
                    resolve(res.message);
                }
            });
        })
    }
    return noteData;
}

/**
 * 只更新项目的基本信息
 * @param project
 */
export const updateProject = (project:any)=>{
    return note.put(project);
}

export const batchUpdateProject = (arrayProjects)=>{
    return note.bulkPut(arrayProjects);
}

/**
 * 更新笔记名称
 * @param noteData
 */
export async function updateNoteName(noteData){
    noteData.doc = '';
    await note.put(noteData);
}

export async function updateNoteLastView(noteData){
    noteData.doc = '';
    noteData.viewTime = noteData.updateTime = Date.now();
    return note.put(noteData);
}

/**
 * 更新对象下所有条目为有更新
 */
export function updateNoteItemToHasUpdate(note:TNote){
    if (isStringNullOrEmpty(note.doc))return;
    const dtNow = Date.now();
    const jsonData = JSON.parse(note.doc);
    for (let i=0;i<jsonData.canvas.length;i++){
        const item = jsonData.canvas[i];
        if (item.isFolder){
            for (let j=0;j<item.children.length;j++){
                item.children[j].hasUpdate = true;
                item.children[j].updateTime = dtNow;
            }
        }else{
            jsonData.canvas[i].hasUpdate = true;
            jsonData.canvas[i].updateTime = dtNow;
        }
    }
    for (let i=0;i<jsonData.notes.length;i++){
        const item = jsonData.notes[i];
        if (item.isFolder){
            for (let j=0;j<item.children.length;j++){
                item.children[j].hasUpdate = true;
                item.children[j].updateTime = dtNow;
            }
        }else{
            jsonData.notes[i].hasUpdate = true;
            jsonData.notes[i].updateTime = dtNow;
        }
    }
    note.doc = JSON.stringify(jsonData);
}

/**
 * 根据tagName过滤project
 * @param szTagName
 */
export function getProjectByTagName(szTagName:string,szSelectedTagName:string,szSearchKey:any){
    return new Promise(async (resolve, reject) => {
        let arrayNotes:any = null;
        if (szSearchKey){
            arrayNotes = await getSearchNoteList(szSearchKey);
        }else{
            arrayNotes = await getNoteList();;
        }
        let arrayProjects = (arrayNotes.filter(p=>p.tags?.includes(szTagName)));
        if (szSelectedTagName){
            arrayProjects = arrayProjects.filter(p=>p.tags.includes(szSelectedTagName))
        }
        arrayProjects.forEach(p=>{
            p.type = 'project';
        })
        resolve(arrayProjects);
    })
}

/**
 * library在project中的引用...
 * @param szLibraryId
 */
export function staticLibraryRefInProject(szItemId:string,hasInterrupt = false){
    return new Promise((resolve, reject) => {
        var arrayProjects:any = [];
        getNoteList().then(async (res:any)=>{
            for (let i=0;i<res.length;i++){
                if (hasInterrupt && !global.g_mapLibraryInfos[szItemId])continue;//有打断的情况并且查询不再有效
                // const doc = await getNoteDoc(res[i].id);
                // if (!doc)continue;
                // let szDoc = doc.doc;
                // if (!isString(doc.doc)){
                //     szDoc = JSON.stringify(szDoc);
                // }
                // var patter0 = new RegExp('"id":"'+szLibraryId,'g');
                // var patter1 = new RegExp('"key":"'+szLibraryId,'g');
                // var patter2 = new RegExp('"id":" '+szLibraryId,'g');
                // var patter3 = new RegExp('"id":'+szLibraryId,'g');
                // var patter4 = new RegExp('"id": "'+szLibraryId,'g');
                // const bMatch = patter0.test(szDoc) || patter1.test(szDoc) || patter2.test(szDoc) || patter3.test(szDoc) || patter4.test(szDoc)
                const doc = await getNoteJsonDoc(res[i].id);
                let bMatch = false;

                await loopAllNodeAsync(doc.canvas,async (item)=>{
                    if (item?.drawJson?.elements){
                        if (!bMatch){
                            bMatch = item.drawJson.elements.some(p=>p.id == szItemId || p.customData?.generationData?.pdfData?.id == szItemId || p.customData?.generationData?.videoData?.id == szItemId || p.customData?.generationData?.id == szItemId);
                        }
                    }
                })
                if (bMatch){
                    res[i].doc = JSON.stringify(doc);
                    arrayProjects.push(res[i])
                }
            }
            resolve(arrayProjects);
        })
    })
}





















